<div class="waveform-container" [style.width.%]="fullWidth() ? 100 : null">
  @for (bar of waveformBars(); track $index) {
    <div class="waveform-bar" [style.height.%]="bar.height"></div>
  }
</div>
